import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
// import { Http} from '@angular/http';
import { GithubService } from '../services/github.service';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { UserdataService } from '../services/userdata.service';
import { DesignService } from '../services/designs.service';
import { SafePipe } from '../pipes/safe-pipe.pipe';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../services/auth.service';
// import * as _ from 'lodash';
import { isEqual } from 'lodash'
import { WindowRefService, ICustomWindow } from '../services/window.service';
import * as LogRocket from 'logrocket';


declare var StripeCheckout:any;
declare var tribed:any;

@Component({
  selector: 'app-build',
  templateUrl: './build.component.html',
  styleUrls: ['./build.component.css']
})


export class BuildComponent implements AfterViewInit {

  location = 'build';
  technologies: string[] = [];
  // tools: string[] = [];
	user: any;
  userData: any;
  MDPuserPrevious: any; // this is an object that we'll compare the user to on input blur, to stop sending requests to the server constantly
	loading: boolean = true;
	stripeDescription: string;
	fullPrice: any;
	salePrice: any;
	themes: any;
	page: any;
  iframeContent: any;
	fullscreenIframe: boolean = false;
	handler: any;
  iframe: any;
  showIframe: boolean = false;
  errors: any = {
    noRepos: false
  };
  view: any = {
    "checkingGithub": false
  };
  tabNum: any = 1;
  newUser: boolean = false;
  showPanel: boolean = true;
  showOnboarding: boolean = false;
  private _window: ICustomWindow;

  constructor(
    private authService: AuthService,
  	private github: GithubService,
  	private userDataService: UserdataService,
  	private router: Router,
    private route: ActivatedRoute,
  	private DesignService: DesignService,
  	public sanitizer:DomSanitizer,
    windowRef: WindowRefService
	) { 
    // get reference to window
    this._window = windowRef.nativeWindow
  }

  @ViewChild('reposElement') reposEl: ElementRef;

  ngOnInit(){
    // check for newb query params
    this.route.queryParams
      .filter(params => params.newb)
      .subscribe(params => {

        if(params.hasOwnProperty("newb")){
          // newb param present, show onboarding
          this.showOnboarding = true
        }

      });
  }

  ngAfterViewInit() {

    // check for user being authenticated
    // get currently authed user
    this.authService.getAuthState()
      .subscribe((user) => {

        if(!user) {
          console.log("no user, nav to home");
          this.router.navigate(["/"])
        } else {

          this.user = user

          // get designs
          this.themes = this.DesignService.getThemes();

          // get userData
          this.userDataService.getData()
            .subscribe(data => {
              this.userData = data;
              // console.log('this.userData:', this.userData)

              // temp fix for portfolio object on user
              if(!this.userData.portfolio || !this.userData.portfolio.projects){
                this.userData.portfolio.projects = []
              }

              // get public repos if there's no repos there...
              if(!this.userData.publicGithubRepos) {
                this.getUserPublicRepos(this.userData.login);
              }

              // whenever there's a change, we should send to node right??
              this.buildSite();

            })
        }

      });


    // get devicons for technologies
    this.getDevicons();
  }

  getDevicons(){
    this.github.getDeviconsJson()
      .subscribe((data) => {

        let tempObj = data["_body"];

        tempObj = JSON.parse(tempObj);

        // process tech names
        for (var i = tempObj.length - 1; i >= 0; i--) {
          let obj = tempObj[i];
          this.technologies.push(obj.name);
          // console.log('obj:',obj)
        }
        
      })
  }

  checkLoading(){
    // console.log('checking loading:', this.user)
    // loading is complete when
    // we have github info
    // we have github repos
    if(this.user.githubInfo && this.user.githubRepos) {
      // loading is finished
      this.loading = false;

      if(this.newUser){
        // handhold user
        this.handholdNewUser();
      } else {
        this.buildSite()
      }
      
    }
  }

  handholdNewUser(){

    if(!this.newUser){
      // lets not do anything if an existing user...
      return
    }

    // otherwise, lets sort by top stargazers
    this.user.githubRepos.sort(function(a,b){
      // sort by stargazer count
      return a['stargazers_count'] - b['stargazers_count']
    })

    this.user.githubRepos.reverse();

    // And select top 3 repos
    for (var i = 0; i < 3; i++) {
      this.user.githubRepos[i]['toShowcase'] = true
    }

    this.buildSite()
  }

  addTechToProject(event, project) {
    let tech = event.value;
    console.log('user is adding tech to project:', tech + ' ' + project);
    if(!project.techUsed){
      project.techUsed = [tech]
    } else {
      project.techUsed.push(tech)
    }
    project.technologyInput = '';

    // save it
    this.saveData()
  }

  removeTechFromProject(tech, project) {
    // console.log('user is removing tech from project:', tech);
    let index = project.techUsed.indexOf(tech);
    if(index > -1){
      project.techUsed.splice(index, 1)
    }
     // save it
    this.saveData()
  }

  getUserPublicRepos(GHusername){
    this.view.checkingGithub = true
    this.github.getReposForUser(GHusername)
      .subscribe(data => {
        // console.log('user public repos:', data);
        this.userData.publicGithubRepos = data;

        this.userData.lastCheckedGithub = new Date();

        // update database
        this.saveData();

        this.view.checkingGithub = false
      })
  }

  selectTheme(theme) {
  	// user is selecting a theme to preview
    console.log('select theme:', theme.name);

  	// set theme on userdata obj
    this.userData.portfolio.theme = theme.name

    // save the data
    this.saveData()
    
  	// re-build
    this.buildSite();

  }

  saveData(){
    console.log("saving data")
    // check MDPuserPrevious, if there's no difference then don't send request
    if (isEqual(this.userData, this.MDPuserPrevious)){
      // no change, don't send request
      console.log('no change, cancelling...')
      return
    }

    // there must have been a change
    // set previous object now
    this.MDPuserPrevious = JSON.parse(JSON.stringify(this.userData));

    // save data
    this.userDataService.saveData(this.userData);

  }

  buildSite() {

    this.loading = true;

    // track in SA
    if(this._window.sa_event){
      this._window.sa_event("site-build");
    }

    LogRocket.track('site-build');

    tribed("event", "site-build");    
    
    let selectedTheme = (this.themes.filter((theme) => theme.name === this.userData.portfolio.theme)[0])
    
  	let buildData = {
  		"user": this.userData,
  		"showcaseRepos": this.userData.portfolio.projects,
  		"knownTechnologies": this.user.knownTechnologies,
  		"tools": this.user.tools,
  		"theme": selectedTheme
  	}

    // get page form designs Service
    this.userData.portfolio.page = this.DesignService.buildSite(buildData);

    // set page as iframe content
    this.iframeContent = this.userData.portfolio.page;

    // disable laoding
    this.loading = false;

    // show iframe
    this.showIframe = true;

    // save data to DB
    this.saveData();

  }


  addProject(){
    console.log('manually add a project');

    LogRocket.track('add-project-to-portfolio');

    tribed("event", "add-project-to-portfolio");    

    let project = {
      "id": guidGenerator(),
      "expanded": true,
      "name": ""
    }

    // lets push this project to userData.portfolio.projects
    // this array might not be on the user object though...
    if(!this.userData.portfolio.projects) {
      this.userData.portfolio.projects = []
    }

    // add project to array
    this.userData.portfolio.projects.unshift(project);

    console.log("user projects now:", this.userData.portfolio.projects)

    this.saveData();

  }

  moveProject(project, dir) {
    console.log('moving project', dir +", project"+project)

    let projects = this.userData.portfolio.projects

    console.log('projects:', projects);

    // get current position of project
    // move it 
    // array_move(arr, old_index, new_index)
    let old_index = projects.findIndex(x => x.id == project.id)
    console.log('index:', old_index);
    
    let new_index
    switch (dir) {
      case "up":
        new_index = old_index--
        break;
      case "down":
        new_index = old_index++
        break
      default:
        break;
    }

    array_move(projects, old_index, new_index)

    this.buildSite()
    
  }

  removeProject(project){
    // user wants to remove a project from the portfolio
    console.log('deleting repo:', project);

    // find project in array
    let position = this.userData.portfolio.projects.indexOf(project);

    console.log('position:', position);

    // remove project from array
    this.userData.portfolio.projects.splice(position, 1);

    // save data
    this.saveData();
  }

  addGithubProject(project){

    project.expanded = true;

    LogRocket.track('add-project-to-portfolio');

    console.log("adding github project to portfolio:", project);

    this.userData.portfolio.projects.push(project);

    // saveData 
    this.saveData();

    // scroll element to top
    this.reposEl.nativeElement.scrollTop = 0;
  }

  hideOnboarding(){

    // hide onboarding
    this.showOnboarding = false;

    // remove query params
    this.router.navigate(["/build"])
  }

  toggleFullscreen() {
    console.log('toggling fullscreen')
    this.fullscreenIframe = !this.fullscreenIframe
  }

}

function guidGenerator() {
    let S4 = function() {
       return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+S4());
}

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};


// WEBPACK FOOTER //
// ./src/app/build/build.component.ts